export default __webpack_public_path__ + "static/media/new_ECS_LOGO_higherresolution.6f0ca11d.png";